module.exports = __webpack_public_path__ + "static/media/marker-SES.a7626edb.svg";